// Import the functions you need from the SDKs you need
import {initializeApp} from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAY_PmACpnr_04EyfeL7TRx6iulKAQTaKg",
  authDomain: "clearloop-6d591.firebaseapp.com",
  databaseURL: "https://clearloop-6d591-default-rtdb.firebaseio.com",
  projectId: "clearloop-6d591",
  storageBucket: "clearloop-6d591.appspot.com",
  messagingSenderId: "716705809629",
  appId: "1:716705809629:web:7fd738f3ba7a1639da4734",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

